<template>
  <b-modal size='delete' class="delete-student-modal" :class="{ changed: choosedLockUser.isUserBlocked }" :visible="show"
    @hide="() => this.$emit('close')" :title="'Block student' | translate" @ok="() => $emit('deleteUser')"
    :ok-title="'Confirm' | translate" :cancel-title="'Cancel' | translate" hide-footer>

    <div v-if="!choosedLockUser.isUserBlocked">
      <p class="change-price-text">{{ "Before blocking, you can change the price for the student" | translate }}</p>

      <div v-if="!!choosedLockUser" class="change-price-wrapper">

        <a class="change-price-name">{{ choosedLockUser.name }}</a>

        <div class="change-price-options">
          <div class="price-input-wrapper">
            <label for="change-price-input" class="price-input-label"
              :class="{ 'new-price': !isOldPrice, changed: choosedLockUser.isPriceChanged }">
              {{ 'Price' | translate }}
            </label>

            <input class="change-price-input" id="change-price-input"
              :class="{ 'new-price': !isOldPrice, changed: choosedLockUser.isPriceChanged }" type="number" step="1"
              v-model="choosedLockUser.price" />
          </div>

          <button class="change-price-button" @click="() => $emit('changePrice')">
            <div class="icon" v-if="!choosedLockUser.isPriceLoading">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fi-rr-pencil" clip-path="url(#clip0_1187_589)">
                  <path id="Vector"
                    d="M15.7356 0.764814C15.2824 0.312279 14.6681 0.0581055 14.0276 0.0581055C13.3871 0.0581055 12.7728 0.312279 12.3196 0.764814L1.47692 11.6075C1.16642 11.9162 0.920229 12.2835 0.752586 12.688C0.584944 13.0925 0.499179 13.5263 0.500254 13.9641V15.3328C0.500254 15.5096 0.570492 15.6792 0.695516 15.8042C0.820541 15.9292 0.99011 15.9995 1.16692 15.9995H2.53559C2.97343 16.0007 3.40717 15.9151 3.81169 15.7476C4.21622 15.58 4.58349 15.3339 4.89225 15.0235L15.7356 4.18015C16.1879 3.72694 16.442 3.11279 16.442 2.47248C16.442 1.83217 16.1879 1.21802 15.7356 0.764814ZM3.94959 14.0808C3.57359 14.4543 3.06556 14.6646 2.53559 14.6661H1.83359V13.9641C1.83291 13.7014 1.88436 13.4412 1.98495 13.1984C2.08553 12.9557 2.23326 12.7354 2.41959 12.5501L10.6483 4.32148L12.1816 5.85481L3.94959 14.0808ZM14.7923 3.23748L13.1216 4.90881L11.5883 3.37881L13.2596 1.70748C13.3603 1.60702 13.4797 1.52737 13.6112 1.47309C13.7427 1.4188 13.8835 1.39094 14.0258 1.3911C14.168 1.39125 14.3088 1.41942 14.4401 1.47399C14.5715 1.52856 14.6908 1.60847 14.7913 1.70915C14.8917 1.80983 14.9714 1.92931 15.0256 2.06077C15.0799 2.19223 15.1078 2.3331 15.1076 2.47533C15.1075 2.61755 15.0793 2.75836 15.0247 2.8897C14.9702 3.02105 14.8903 3.14035 14.7896 3.24081L14.7923 3.23748Z"
                    fill="#150722" />
                </g>
                <defs>
                  <clipPath id="clip0_1187_589">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="icon-spinner">
              <div v-if="choosedLockUser.isPriceLoading" class="spinner-border spinner-border-sm" role="status" />
            </div>

            {{ 'Change' | translate }}
          </button>
        </div>

      </div>

      <div class="block-button-area">
        <b-button @click="() => $emit('deleteUser')" class="block-button" :disabled="isConfirmBlocked">
          {{ 'Block' | translate }}
        </b-button>
      </div>
    </div>

    <div class="change-done" v-else>
      <div>
        <svg width="281" height="238" viewBox="0 0 281 238" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M44.3038 122.499C41.2463 145.462 20.886 170.451 34.0478 189.514C47.5632 209.09 78.7351 199.714 101.755 205.71C118.455 210.059 133.398 223.458 150.259 219.783C166.888 216.159 173.056 195.589 187.732 186.971C211.101 173.248 246.502 178.408 260.367 155.123C274.358 131.626 274.664 93.4812 254.212 75.3267C232.193 55.7815 196.099 82.2177 168.073 73.1976C147.224 66.4876 140.689 35.538 119.101 31.8424C95.4248 27.7893 67.4634 34.8293 52.1767 53.3574C37.0441 71.6984 47.442 98.9287 44.3038 122.499Z"
            fill="#E8FFE1" />
          <circle cx="24.367" cy="109.193" r="4.68169" transform="rotate(-45 24.367 109.193)" stroke="#68BC50"
            stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="118.067" cy="38.1772" r="4.68169" transform="rotate(-45 118.067 38.1772)" stroke="#68BC50"
            stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="260.098" cy="124.973" r="4.68169" transform="rotate(-45 260.098 124.973)" stroke="#68BC50"
            stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 201.938L15.2418 201.938M8.62091 208.559L8.62091 195.318" stroke="#68BC50" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M44.377 15.4927L57.6188 15.4927M50.9979 22.1136L50.9979 8.87176" stroke="#68BC50" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M208.139 216.735L221.381 216.735M214.76 223.356L214.76 210.114" stroke="#68BC50" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M247.593 8.62109L260.835 8.62109M254.214 15.242L254.214 2.00018" stroke="#68BC50" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M108.981 116.873L137.972 145.864C138.813 146.704 140.201 146.616 140.928 145.675L198.243 71.5024"
            stroke="#68BC50" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M188.489 101.888C192.825 110.033 195.283 119.329 195.283 129.2C195.283 161.339 169.229 187.393 137.091 187.393C104.952 187.393 78.8979 161.339 78.8979 129.2C78.8979 97.0615 104.952 71.0078 137.091 71.0078C151.442 71.0078 164.581 76.2034 174.728 84.8162"
            stroke="#68BC50" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <p class='change-done-header' v-if="choosedLockUser.isPriceChanged">
        {{ 'The student is blocked with a new price' | translate }}
      </p>

      <p class='change-done-header' v-else>{{ 'The student is blocked' | translate }}</p>

      <p class='change-done-text'>{{ 'To unlock this student, go to the "Restore" section' | translate }}</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'modal-delete-student',
  props: ['show', 'choosedLockUser'],
  computed: {
    isOldPrice() {
      return this.choosedLockUser.price == this.choosedLockUser.oldPrice
    },
    isConfirmBlocked() {
      return !this.isOldPrice && !this.choosedLockUser.isPriceChanged
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.delete-student-modal.changed .modal-title {
  display: none;
}

.delete-student-modal.changed .modal-delete {
  max-width: 700px !important;
}

.delete-student-modal {
  font-family: Montserrat;

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .change-done {
    text-align: center;
  }

  .change-done-header {
    font-size: 26px;
    font-style: normal;
    font-weight: 700;

    margin-top: 50px;
  }

  .change-done-text {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }

  & button.close {
    background-color: #F1F2F5;
    padding: 4px 10px;

    border-radius: 50%;
  }

  .modal .modal-title {
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
  }



  .modal .modal-delete {
    max-width: 700px !important;

    & .modal-content {
      max-width: 100% !important;

      padding: 15px;
    }
  }

  .modal-body {
    display: block;
  }

  .change-price-text {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }

  .change-price-wrapper {
    display: flex;

    justify-content: space-evenly;
    align-items: center;
    padding: 24px;
    flex-wrap: wrap;
    border-radius: 8px;
    background: #F1F6FA;
  }

  .change-price-options {
    display: flex;

    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;

  }

  .change-price-name {
    color: #131A26;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    // line-height: 26px;
  }

  .price-input-wrapper {
    position: relative;
    margin-right: 10px;
  }

  .price-input-label {
    position: absolute;

    line-height: 100%;
    left: 10px;
    top: -7px;
    margin: 0;

    padding: 2px 5px;

    font-size: 12px;

    border-radius: 8px;

    background-color: #F1F6FA;

    transition: all 0.2s ease;
  }

  .change-price-input {
    // width: 212px;
    // height: 42px;
    padding: 10px 16px;

    // margin-right: 10px;

    border-radius: 8px;
    border: 1px solid #B7AFBF;
    background: #F1F6FA;

    transition: all 0.2s ease;

  }

  .change-price-input.new-price {
    border: 1px solid #5DCF3C;
    background: #E8FFE1;
  }

  // .change-price-input:focus.new-price {
  //   border-color: #5DCF3C !important;
  //   // background: #E8FFE1;
  // }

  .change-price-input.changed {
    color: #FFF;
    background: #5DCF3C;
  }

  .price-input-label.new-price {
    border: 1px solid #5DCF3C;
    background: #E8FFE1;
  }

  .price-input-label.changed {
    color: #FFF;
    background: #5DCF3C;
  }

  .change-price-button {
    // width: 143px;
    // height: 40px;
    display: flex;
    align-items: center;

    padding: 10px 16px;

    border-radius: 12px;
    border: 1px solid #FAB610;

    background: #F1F6FA;

    & .icon {
      width: 17px;
      height: 17px;

      margin: 0 0 6px 0;
    }

    & .icon-spinner {
      margin-right: 8px;
    }
  }

  .modal-footer {
    justify-content: right;

    border-top: 0px solid red !important;
  }

  .block-button-area {
    text-align: right;

    padding: 15px 0;
  }

  .block-button {
    // width: 256px;
    // height: 48px;
    padding: 10px 25px;
    // justify-content: center;
    // align-items: center;
    // gap: 10px;

    border-radius: 12px;
    border-color: #FAB610;
    background: #FAB610 !important;

    color: #FFF !important;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;

    &.disabled {
      border: 1px solid #FAB610 !important;
    }
  }


}

.delete-student-modal.changed .modal-title {
  display: none;
}

.delete-student-modal.changed .modal-delete {
  max-width: 380px !important;

  & .modal-content {
    max-width: 100% !important;

    padding: 30px;
  }
}
</style>